import {List} from 'immutable';
export default List([
  {label: 'Day', value: 1},
  {label: 'Week', value: 7},
  {label: 'Month', value: 30},
]);
